// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FileDiff as RawFileDiff } from "lucide-react";
export const FileDiff = /* @__PURE__ */ createIcon(RawFileDiff, "FileDiff", 2);
